export default "__VITE_ASSET__47b5c296__"